const Format = {
    Date: {
        _monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        getLongMonthYear: function (dateString) {
            if (!dateString) {
                return '';
            }
            const date = new Date(dateString);
            if (!date) {
                return;
            }
            return `${Format.Date._monthNames[date.getMonth()]} ${date.getFullYear()}`;
        }
    }
};

export default Format;